module.exports = __webpack_public_path__ + "img/800_5e043acac43ed.16861490.jpg";